export default "__VITE_ASSET__CAOp1u9F__"